const Broken = () => {
  return (
    <div className="text-center rounded-xl text-gray-600 px-16 py-8 shadow-md shadow-gray-300">
        <h1 className="text-xl font-semibold">Oops! Something seems broken😟</h1>
        <h1 className="text-md">We'll be right back soon!</h1>
    </div>
  )
}

export default Broken